import { v4 as uuidv4 } from 'uuid';
import mock from '../config/mock';

mock.onGet('/api/agencies').reply(200, {

    agencies: [
        {
            id: uuidv4(),
            name: 'agency001',
            email: 'asd@asd.com',
            contact: '0987654321',
        },
        {
            id: uuidv4(),
            name: 'agency002',
            email: 'qwe@qwe.com',
            contact: '0987654321',
        },
        {
            id: uuidv4(),
            name: 'agency003',
            email: 'bnm@bnm.com',
            contact: '0987654321',
        },
    ]
});